import React, { FC, MouseEventHandler } from 'react'

export type CheckboxValue = 'checked' | 'unchecked' | 'indeterminate'

export type CheckboxProps = {
  value: CheckboxValue
  color: string
  disabled?: boolean
  onClick: MouseEventHandler<HTMLDivElement>
}

export const Checkbox: FC<CheckboxProps> = (props) => {
  const { value, color, onClick, disabled = false } = props

  const bgColor = disabled ? 'grey' : color

  return (
    <div
      onClick={onClick}
      style={{
        position: 'relative',
        width: '20px',
        height: '20px',
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
    >
      <div
        style={{
          width: '20px',
          height: '20px',
          background: disabled ? 'lightgrey' : 'white',
        }}
        className='border border-gray-200 rounded relative'
      />

      {value === 'indeterminate' ? (
        <div
          style={{
            position: 'absolute',
            top: '8px',
            left: '3px',
            width: '14px',
            height: '4px',
            borderRadius: '2px',
            background: bgColor,
          }}
        />
      ) : (
        <div
          style={{
            position: 'absolute',
            left: '4px',
            top: '4px',
            width: '12px',
            height: '12px',
            borderRadius: '2px',
            background: value === 'checked' ? bgColor : 'white',
          }}
        />
      )}
    </div>
  )
}
